// @flow
import pipe from 'ramda/es/pipe';
import values from 'ramda/es/values';
import map from 'ramda/es/map';
import prop from 'ramda/es/prop';
import keys from 'ramda/es/keys';
import identity from 'ramda/es/identity';
import filter from 'ramda/es/filter';

import type { Params, ScheduleDay, Subject } from 'app/dataTypes/ScheduleDay.types';
import type { Mark } from 'app/dataTypes/Mark.types';

import type { Request } from '../../index';


const dateFormatApi: 'YYYY-MM-DD' = 'YYYY-MM-DD';

type ParamsApi = {
  klass_id?: number,
  student_id: number,
  date: string,
}

export const convertParams = (params: Params): [ParamsApi, null] => {
  const { studentId, klassId, date } = params;

  return [filter(identity, {
    student_id: parseInt(studentId, 10),
    klass_id: parseInt(klassId, 10),
    date: date.getString(dateFormatApi),
  }), null];
};

type DateApi = {
  [lesson_num: string]: {
    schedule_id: number,
    discipline: string,
    homework: string,
    marks: Array<{
      value: string,
      description: string,
    }>
  },
}

type ResultApi = {
  [date: string]: DateApi,
  result: 'success',
}

const convertMarks = (marksMaybe: Array<Object>): Array<Mark> => {
  if (marksMaybe && marksMaybe instanceof Array) {
    return pipe(
      map(({ value, description }) => (value || value === 0 ? {
        value: String(value),
        description: description || null,
      } : null)),
      filter(identity),
    )(marksMaybe);
  }
  return [];
};

export const convertResult = (res: ResultApi): ScheduleDay => {
  const { result, ...datesMap } = res;
  const date = prop(0, keys(datesMap));
  const subjects = date ? datesMap[date] : null;

  if (!subjects) {
    return [];
  }

  return pipe(
    values,
    map(({
      schedule_id: id,
      discipline,
      marks,
      homework,
    }): Subject => ({
      id: String(id),
      title: discipline || '',
      marks: convertMarks(marks),
      homeworkTask: homework || '',
    })),
  )(subjects);
};

export const GET_DAY: Request<
  Params,
  ScheduleDay,
  void
> = [
  'cabinet/dnevnik/day',
  'get',
  ['data'],
];
